import { type ObjectValuesUnionType } from '../../utils/typing';

export const CommonActionTypes = Object.freeze({
  RECEIVE_ENTITIES: 'RECEIVE:ENTITIES',
  API_CALL: 'API:CALL',
  TRACKING: 'TRACKING',
});
export type CommonActionType = ObjectValuesUnionType<typeof CommonActionTypes>;

export const StorageActionTypes = Object.freeze({
  BASKET_SAVE: 'STORAGE:BASKET_SAVE',
});
export type StorageActionType = ObjectValuesUnionType<typeof StorageActionTypes>;

export const StreamingActionTypes = Object.freeze({
  GET_STREAMINGURL: 'GET:STREAMINGURL',
  GET_STREAMINGURL_OK: 'GET:STREAMINGURL_OK',
  GET_STREAMINGURL_KO: 'GET:STREAMINGURL_KO',
});
export type StreamingActionType = ObjectValuesUnionType<typeof StreamingActionTypes>;

export const MenuActionTypes = Object.freeze({
  RESET: 'MENU:RESET',
  ADD_KEY: 'MENU:ADD_KEY',
  SET_KEY: 'MENU:SET_KEY',
});
export type MenuActionType = ObjectValuesUnionType<typeof MenuActionTypes>;

export const FlowActionTypes = Object.freeze({
  STOP_ACTION: 'FLOW:STOP_ACTION',
});
export type FlowActionType = ObjectValuesUnionType<typeof FlowActionTypes>;
